module.exports = __webpack_public_path__ + "img/店铺发货.19127a3a.svg";